module.exports = __webpack_public_path__ + "img/codeine.227d8e45.png";